import styled from 'styled-components';

import { getSuneditorCssClassNames } from '@dreryk/react-text-editor';

import { DICTATION_PREVIEW_CLASS } from '../textEditorField/textEditorField.utils';

const { container } = getSuneditorCssClassNames();

export const StyledSummaryModalField = styled.div`
   height: 172px;

   .${container} {
      background-color: ${(props) => props.theme.backgroundInput};
   }

   .${DICTATION_PREVIEW_CLASS} {
      color: ${(props) => props.theme.disabledDarker};
      font-style: italic;
   }
`;

StyledSummaryModalField.displayName = 'StyledSummaryModalField';
